import { HomeOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthProvider/AuthProvider";

export const Login = () => {
  const [value, setValue] = useState<string>("");
  const [value2, setValue2] = useState<string>("");
  const nav = useNavigate();
  const { login } = useAuth();

  const handleForm = () => {
    login(value, value2);
    nav("/tools");
  };

  return (
    <div className=" bg-[#1f1e23] w-full h-full flex flex-col items-center justify-center text-white">
      <div
        style={{
          //width: "100vw",
          height: "100vh",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div className="flex flex-col items-center justify-center w-full">
          <div
            className=" text-white font-semibold mb-6 mt-10 font-bold, text-2xl"
            style={{ fontFamily: "oxanium" }}
          >
            LOGIN
          </div>
          <div className="m-1">
            <Input
              id="userName"
              style={{ width: "250px" }}
              value={value}
              placeholder="User name"
              onChange={(e) => {
                setValue(e.target.value);
              }}
            />
          </div>
          <div className="m-2">
            <Input.Password
              id="password"
              style={{ width: "250px" }}
              value={value2}
              placeholder="Password"
              onChange={(e) => {
                setValue2(e.target.value);
              }}
            />
          </div>
          <div>
            <Button
              type="primary"
              onClick={() => handleForm()}
              style={{ fontFamily: "oxanium", marginTop: "1rem" }}
            >
              Login
            </Button>
          </div>
          <Button
            type="text"
            style={{ fontFamily: "Oxanium", marginTop: "2rem", color: "white" }}
            icon={<HomeOutlined />}
            onClick={() => nav("/")}
          />
        </div>
      </div>
    </div>
  );
};
